import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/plans/')({
  beforeLoad: () => {
    throw redirect({to: '/settings/nutrition-plans', replace: true});
  },
});
